import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { updateUserData } from '../../profile/userSlice';

export enum CustomFeatureClient {
  PAM = 'pam',
}

export enum AccessLevel {
  User = '1',
  FriendsAndFamily = '2',
  Leadership = '3',
  ChildClientAdmin = '4',
  ParentClientAdmin = '5',
  Translation = '8',
  LimitedAdmin = '9',
  Admin = '10',
}
interface SSO {
  _id: string;
  clientId: string;
  type: string;
  platform: string;
  redirect_uri?: string;
  id?: string;
  scope?: string;
  issuer?: string;
  secret?: string;
}

interface UserData {
  domain_validation: boolean;
  fandfUser: string;
  fnfDisabled?: boolean;
  id?: string;
  isGoogleAuthActive: boolean;
  isMicrosoftAuthActive: boolean;
  isStandardAuthActive: boolean;
  logo?: string;
  logo_dark?: string;
  eapPhoneNumber?: string;
  emergencyPhoneNumber?: string;
  customFeatureClient?: CustomFeatureClient;
  open?: string;
  singleSignOn: Array<SSO>;
  valid?: string;
  token?: string;
  expiration?: string;
  fname?: string;
  access?: AccessLevel;
  usageId?: string | boolean;
  image?: string;
  clientName?: string;
  npsStatus?: string;
  authType?: string;
  email?: string;
  isHub?: boolean;
  clientid?: string;
  dept?: string;
  userId?: string;
  pamClientCode?: string;
}

export const useUserData = () => {
  const dispatch = useDispatch();
  const userData = useSelector<unknown, UserData | undefined>(
    (state: any) => state.user.userData,
    shallowEqual
  );

  const persistUserData = useCallback(
    (data: UserData) => {
      dispatch(updateUserData(data));
    },
    [dispatch]
  );

  const appendUserData = useCallback(
    (data: Partial<UserData>) => {
      if (userData) {
        const updatedUserData = { ...userData, ...data };

        dispatch(updateUserData(updatedUserData));
      } else {
        dispatch(updateUserData(data));
      }
    },
    [dispatch, userData]
  );

  return {
    userData,
    persistUserData,
    appendUserData,
  };
};
